import "../../Styles/Admin/Header.css"; 
import React from "react";
const Header = ({ title ,description,icon }) => {
	return (
		 <div className="ap-header">
        <div className="ap-header-icon">
          {icon}
        </div>
        <div className="ap-header-text">
          <h1>{title}</h1>
          <p className="ap-subtitle">
			{description}
			</p>
        </div>
      </div>
	);
};

export default Header;
